import {
  IBetalingsregelingAanvragenEndpointClient,
  BetalingsregelingAanvragenEndpointClient,
  IKlachtIndienenEndpointClient,
  KlachtIndienenEndpointClient,
  IBewindvoerdersEnCuratorenContactAanvragenEndpointClient,
  BewindvoerdersEnCuratorenContactAanvragenEndpointClient,
  IBewindvoerdersEnCuratorenClientAanmeldenEndpointClient,
  BewindvoerdersEnCuratorenClientAanmeldenEndpointClient,
  IBewindvoerdersEnCuratorenClientWijzigenEndpointClient,
  BewindvoerdersEnCuratorenClientWijzigenEndpointClient,
  IContactAanvragenEndpointClient,
  ContactAanvragenEndpointClient
} from "./client.generated";
import axios, { AxiosInstance } from "axios";

export class ClientFactory {
  private readonly baseUrl: string;
  private readonly instance?: AxiosInstance;

  constructor(apiUrl) {
    this.baseUrl = apiUrl;
    this.instance = axios;
  }

  getBetalingsRegelingClient = (): IBetalingsregelingAanvragenEndpointClient => {
    return new BetalingsregelingAanvragenEndpointClient(this.baseUrl, this.instance);
  };

  getKlachtIndienenEndpointClient = (): IKlachtIndienenEndpointClient => {
    return new KlachtIndienenEndpointClient(this.baseUrl, this.instance);
  };

  getBewindvoerdersCuratorenContactAanvragenEndpointClient =
    (): IBewindvoerdersEnCuratorenContactAanvragenEndpointClient => {
      return new BewindvoerdersEnCuratorenContactAanvragenEndpointClient(this.baseUrl, this.instance);
    };

  getBewindvoerdersCuratorenClientAanmeldenEndpointClient =
    (): IBewindvoerdersEnCuratorenClientAanmeldenEndpointClient => {
      return new BewindvoerdersEnCuratorenClientAanmeldenEndpointClient(this.baseUrl, this.instance);
    };

  getBewindvoerdersEnCuratorenClientWijzigenEndpointClient =
    (): IBewindvoerdersEnCuratorenClientWijzigenEndpointClient => {
      return new BewindvoerdersEnCuratorenClientWijzigenEndpointClient(this.baseUrl, this.instance);
    };

  getContactAanvragenEndpointClient = (): IContactAanvragenEndpointClient => {
    return new ContactAanvragenEndpointClient(this.baseUrl, this.instance);
  };
}
